import { createAsyncThunk } from "@reduxjs/toolkit";
import { removeDatafeedClips } from "store/clip/slice";

import magnifiAPI from "../../services/api/magnifi";

export const getDataFeedStatsPerformMetadata = createAsyncThunk("datafeed/getStatsPerformMetadata", async (payload) => {
  try {
    const response = await magnifiAPI.getDataFeedStatsPerformMetadata(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getDataFeedMatches = createAsyncThunk("datafeed/getDataFeedMatches", async (payload) => {
  try {
    const response = await magnifiAPI.getDataFeedMatches(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getDataFeedStatsPerformPersons = createAsyncThunk("datafeed/getStatsPerformPersons", async (payload) => {
  try {
    const response = await magnifiAPI.getDataFeedStatsPerformPersons(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getDataFeedStatsPerformMatchId = createAsyncThunk("datafeed/getStatsPerformMatchId", async (payload) => {
  try {
    const response = await magnifiAPI.getDataFeedStatsPerformMatchId(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getDataFeedStatsPerformBallOutcome = createAsyncThunk(
  "datafeed/getStatsPerformBallOutcome",
  async (payload) => {
    try {
      const response = await magnifiAPI.getDataFeedStatsPerformBallOutcome(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getDataFeedStatsPerformPlayerAction = createAsyncThunk(
  "datafeed/getStatsPerformPlayerAction",
  async (payload) => {
    try {
      const response = await magnifiAPI.getStatsPerformPlayerAction(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getDataFeedStatsPerformFilters = createAsyncThunk("datafeed/getStatsPerformFilters", async (payload) => {
  try {
    const response = await magnifiAPI.getDataFeedStatsPerformFilters(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
export const getDataFeedStatsPerformSoccerFilters = createAsyncThunk(
  "datafeed/getStatsPerformSoccerFilters",
  async (payload) => {
    try {
      const response = await magnifiAPI.getDataFeedStatsPerformSoccerFilters(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getDataFeedStatsPerformBallIdForFilters = createAsyncThunk(
  "datafeed/getDataFeedStatsPerformBallIdForFilters",
  async (payload) => {
    try {
      const response = await magnifiAPI.getDataFeedStatsPerformBallIdForFilters(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getDataFeedStatsPerformEplMetadata = createAsyncThunk(
  "datafeed/getDataFeedStatsPerformEplMetadata",
  async (payload) => {
    try {
      const response = await magnifiAPI.getDataFeedStatsPerformEplMetadata(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getDataFeedVolleyStationFilters = createAsyncThunk(
  "datafeed/getDataFeedVolleyStationFilters",
  async (payload) => {
    try {
      const response = await magnifiAPI.getDataFeedVolleyStationFilters(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getDataFeedSportradarHandballFilters = createAsyncThunk(
  "datafeed/getDataFeedSportradarHandballFilters",
  async (payload) => {
    try {
      const response = await magnifiAPI.getDataFeedSportradarHandballFilters(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getDataFeedSportMediaTennisFilters = createAsyncThunk(
  "datafeed/getDataFeedSportMediaTennisFilters",
  async (payload) => {
    try {
      const response = await magnifiAPI.getDataFeedSportMediaTennisFilters(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getDataFeedVideoFilters = createAsyncThunk("datafeed/getDataFeedVideoFilters", async (payload) => {
  try {
    const response = await magnifiAPI.getDataFeedVideoFilters(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const startDatafeedClipCuttingJob = createAsyncThunk(
  "datafeed/startDatafeedClipCuttingJob",
  async (payload, { dispatch }) => {
    try {
      const response = await magnifiAPI.startDatafeedClipCuttingJob(payload);

      if (payload?.deleteClips) {
        dispatch(removeDatafeedClips({ time: payload.startTime }));
      }

      return response.data;
    } catch (error) {
      console.error(error);
      throw error?.response?.data?.error;
    }
  },
);

export const stopDatafeedClipCuttingJob = createAsyncThunk("datafeed/stopDatafeedClipCuttingJob", async (payload) => {
  try {
    const response = await magnifiAPI.stopDatafeedClipCuttingJob(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getDataFeedNascarFilters = createAsyncThunk("datafeed/getDataFeedNascarFilters", async (payload) => {
  try {
    const response = await magnifiAPI.getDataFeedNascarFilters(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getDataFeedOlympicIceHockeyFilters = createAsyncThunk(
  "datafeed/getDataFeedOlympicIceHockeyFilters",
  async (payload) => {
    try {
      const response = await magnifiAPI.getDataFeedOlympicIceHockeyFilters(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getDataFeedOlympicCurlingFilters = createAsyncThunk(
  "datafeed/getDataFeedOlympicCurlingFilters",
  async (payload) => {
    try {
      const response = await magnifiAPI.getDataFeedOlympicCurlingFilters(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getDataFeedCBSAmericanFootballFilters = createAsyncThunk(
  "datafeed/getDataFeedCBSAmericanFootballFilters",
  async (payload) => {
    try {
      const response = await magnifiAPI.getDataFeedCBSAmericanFootballFilters(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getDataFeedGraphicsData = createAsyncThunk("datafeed/getDataFeedGraphicsData", async (payload) => {
  try {
    const response = await magnifiAPI.getDataFeedGraphicsData(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getDatafeedOrganizationConfig = createAsyncThunk(
  "datafeed/getDatafeedOrganizationConfig",
  async (payload) => {
    try {
      const response = await magnifiAPI.getDatafeedOrganizationConfig(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getAllDatafeedConfigsForOrganization = createAsyncThunk(
  "datafeed/getAllDatafeedConfigsForOrganization",
  async (payload) => {
    try {
      const response = await magnifiAPI.getAllDatafeedConfigsForOrganization(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const getDatafeedMappedMatch = createAsyncThunk("datafeed/getDatafeedMappedMatch", async (payload) => {
  try {
    const response = await magnifiAPI.getDatafeedMappedMatch(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getDataFeedCBSBasketballFilters = createAsyncThunk(
  "datafeed/getDataFeedCBSBasketballFilters",
  async (payload) => {
    try {
      const response = await magnifiAPI.getDataFeedCBSBasketballFilters(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const createDatafeedConfig = createAsyncThunk("datafeed/createDatafeedConfig", async (payload) => {
  try {
    const response = await magnifiAPI.createDatafeedConfig(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateDatafeedConfig = createAsyncThunk("datafeed/updateDatafeedConfig", async (payload) => {
  try {
    const response = await magnifiAPI.updateDatafeedConfig(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const updateDatafeedConfigDetails = createAsyncThunk("datafeed/updateDatafeedConfigDetails", async (payload) => {
  try {
    const response = await magnifiAPI.updateDatafeedConfigDetails(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getAllDatafeedConfigs = createAsyncThunk("datafeed/getAllDatafeedConfigs", async (payload) => {
  try {
    const response = await magnifiAPI.getAllDatafeedConfigs({
      page_no: payload.page_no,
      limit: payload.limit,
      search_text: payload.search_text,
    });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const triggerDatafeedManualIngestion = createAsyncThunk(
  "datafeed/triggerDatafeedManualIngestion",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await magnifiAPI.triggerDatafeedManualIngestion(payload);

      return response.data;
    } catch (error) {
      console.error(error);

      return rejectWithValue(error?.response?.data || { message: "Something went wrong. Please try again." });
    }
  },
);
